import { apiUrl } from "../api/config";

/**
 * Resolves an image URL by checking if it's absolute or relative
 * @param {string|null|undefined} imageUrl - The image URL to resolve
 * @returns {string|null} The resolved image URL or null if no URL provided
 */
export const resolveImageUrl = (imageUrl) => {
  if (!imageUrl) return null;

  if (imageUrl.startsWith("http")) {
    return imageUrl;
  }

  return apiUrl + imageUrl;
};
